import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {catchError, Observable} from 'rxjs';
import {IKtTripChangeLogItem} from '../interfaces/kt-trip.interface';

/**
 * Reads the SalesOrderChangeLog field-level audit trail for one trip
 * (GetSalesOrderChangeLogQuery / SalesOrderChangeLogsController). Read-only,
 * append-only source table -- there is no create/update here.
 */
@Injectable({
  providedIn: 'root',
})
export class KtTripChangeLogService {
  private readonly http = inject(HttpClient);

  getChangeLog(salesOrderId: number): Observable<IKtTripChangeLogItem[]> {
    return this.http.get<IKtTripChangeLogItem[]>('tmt/sales-order-change-logs', {
      params: {salesOrderId},
    }).pipe(catchError((error: HttpErrorResponse) => {
      throw new Error(error?.error?.detail || error?.message || 'Server error');
    }));
  }
}
